import React from 'react';
import REACTOApp from './REACTOApp';

function App() {
  return <REACTOApp />;
}

export default App;
